import Icon from '../components/Icon.vue'

Icon.register({
  'pepper-hot': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M330.7 263.1h107.5l37 38.5c-48.5 87.5-206.5 210.3-419.2 210.3-30.9 0-56-25.1-56-56s25.1-56 56-56c141.6 0 163.4-181.2 221.9-250.8l52.8 24.2v89.7zM461.8 134.8c27.7 25.3 50.2 76.3 50.2 113.8v0.1c0 13.7-2.3 26.7-5.6 39.3l-54.7-56.9h-89.1v-78.2l-74.7-34.3c22.3-14 48.3-22.6 76.3-22.6 16.5 0 42.1 5.4 57.2 12 18.5-37.2 8.3-62 1.4-72.3-0.8-1.1-1.4-3.2-1.4-4.6 0-1.8 1-4.4 2.3-5.7l22.9-23c1.3-1.3 3.9-2.4 5.7-2.4 2.1 0 4.9 1.3 6.2 3 18.6 23.5 35.3 71.9 3.1 131.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pepper-hot.js
// module id = 1628
// module chunks = 0